// src/routes.js
import React from 'react';
import {
    BrowserRouter as Router,
    Route
} from 'react-router-dom';

import withTracker from './lib/withTracker';

import { hot } from 'react-hot-loader'

import Main from './components/main'
// import DebugConsole from './components/debug-console'

const Routes = props => (
<Router {...props}>
  <div>
    <Route component={withTracker(Main)} path="/" />
    {/* <DebugConsole /> */}
  </div>
</Router>
)

export default Routes


// WEBPACK FOOTER //
// ./src/routes.js